// extracted by mini-css-extract-plugin
var _1 = "l6QsZ";
var _2 = "fwDEH";
var _3 = "Z3DNg";
var _4 = "Dqjoh";
var _5 = "oA_Ku";
var _6 = "xvFtd";
export { _1 as "base", _2 as "close", _3 as "icon", _4 as "is-movable", _5 as "theme-dark", _6 as "theme-light" }
